import useGlobalContext from "@hooks/useGlobalContext";

export default function Logout() {
  const { signOut } = useGlobalContext();

  signOut();

  return null;
}
